import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { PlayIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { SectionHeader } from './SectionHeader';
const VIDEOS = [{
  title: 'RuslanSilvr - Button Up',
  views: '',
  image: 'https://img.youtube.com/vi/y0TWu1JN6pQ/maxresdefault.jpg',
  url: 'https://youtu.be/y0TWu1JN6pQ?si=9Af6Tm2qi8nShoMX'
}, {
  title: 'RuslanSilvr - whatever reason',
  views: '',
  image: 'https://cdn.magicpatterns.com/uploads/bx7C2PAmtmoW7CyLa3cbcb/Untitled_design-5.png',
  url: 'https://youtu.be/fh11xaz0oeI?si=jJo31FE3_6XX6akZ'
}, {
  title: 'RuslanSilvr - Lighter',
  views: '',
  image: 'https://img.youtube.com/vi/gH44Rch6C0I/maxresdefault.jpg',
  url: 'https://youtu.be/gH44Rch6C0I?si=Kii9VIHWBP1thCFY'
}, {
  title: 'RuslanSilvr - juk',
  views: '',
  image: 'https://img.youtube.com/vi/VCRWtOgMBHQ/maxresdefault.jpg',
  url: 'https://youtu.be/VCRWtOgMBHQ?si=BlyGnPc0mNIiwpJs'
}];
export function Videos() {
  const trackRef = useRef<HTMLDivElement>(null);
  const scrollByCard = (direction: 1 | -1) => {
    const track = trackRef.current;
    if (!track) return;
    const firstCard = track.querySelector<HTMLElement>('[data-card]');
    const amount = firstCard ? firstCard.offsetWidth + 32 : track.clientWidth * 0.8;
    track.scrollBy({
      left: amount * direction,
      behavior: 'smooth'
    });
  };
  return <section id="videos" className="py-24 md:py-32 px-6 md:px-12 max-w-screen-2xl mx-auto" data-id="element-101">
      <div className="flex items-end justify-between gap-6" data-id="element-102">
        <div className="flex-1" data-id="element-103">
          <SectionHeader number="04" title="Visuals" data-id="element-104" />
        </div>
        <div className="hidden md:flex items-center gap-3 mb-12 md:mb-20" data-id="element-105">
          <button type="button" onClick={() => scrollByCard(-1)} aria-label="Previous videos" className="w-12 h-12 rounded-full border border-brand-white/20 flex items-center justify-center text-brand-white hover:bg-brand-accent hover:border-brand-accent transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-2 focus-visible:ring-offset-brand-black" data-id="element-106">
            <ChevronLeftIcon className="w-5 h-5" data-id="element-107" />
          </button>
          <button type="button" onClick={() => scrollByCard(1)} aria-label="Next videos" className="w-12 h-12 rounded-full border border-brand-white/20 flex items-center justify-center text-brand-white hover:bg-brand-accent hover:border-brand-accent transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-2 focus-visible:ring-offset-brand-black" data-id="element-108">
            <ChevronRightIcon className="w-5 h-5" data-id="element-109" />
          </button>
        </div>
      </div>

      {/* Videos Carousel */}
      <div ref={trackRef} className="flex gap-8 overflow-x-auto snap-x snap-mandatory pb-4 -mx-6 px-6 md:mx-0 md:px-0 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden" data-id="element-110">
        {VIDEOS.map((video, i) => {
        const Wrapper: any = video.url ? motion.a : motion.div;
        const linkProps = video.url ? {
          href: video.url,
          target: '_blank',
          rel: 'noopener noreferrer'
        } : {};
        return <Wrapper key={video.title} data-card {...linkProps} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          duration: 0.6
        }} className="group cursor-pointer block shrink-0 w-[85vw] sm:w-96 lg:w-[28rem] snap-start focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-4 focus-visible:ring-offset-brand-black" data-id="element-111">
              <div className="relative aspect-video mb-4 overflow-hidden bg-brand-surface" data-id="element-112">
                <img src={video.image} alt={video.title} draggable={false} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-113" />
                <div className="absolute inset-0 bg-brand-black/20 group-hover:bg-brand-black/40 transition-colors duration-300 flex items-center justify-center" data-id="element-114">
                  <div className="w-16 h-16 rounded-full border-2 border-brand-white flex items-center justify-center backdrop-blur-sm group-hover:bg-brand-accent group-hover:border-brand-accent transition-all duration-300 group-hover:scale-110" data-id="element-115">
                    <PlayIcon className="w-6 h-6 text-brand-white fill-current ml-1" data-id="element-116" />
                  </div>
                </div>
              </div>
              <h4 className="font-display text-xl text-brand-white uppercase tracking-wider mb-1" data-id="element-117">
                {video.title}
              </h4>
              {video.views && <p className="text-brand-muted text-sm uppercase tracking-widest" data-id="element-118">
                  {video.views}
                </p>}
            </Wrapper>;
      })}
      </div>
    </section>;
}